import { dispatchSendSocketMessage } from 'store/dispatcher'

import * as constants from './constants'

export const sendEmoji = (id = '') => {
    const data = {
        type: constants.EMOJI,
        id,
    }

    dispatchSendSocketMessage({ action: constants.REACTION, data })
}

export const sendGiphy = (id = '') => {
    const data = {
        type: constants.GIPHY,
        id,
    }

    dispatchSendSocketMessage({ action: constants.REACTION, data })
}
